class AccordionElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.has-submenu');

    if (!this.details || !this.summary || !this.content) return;

    if (this.details.open) {
      this.content.classList.add('is-open');
      this.content.style.height = 'auto';
    }

    this.summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (this.details.open) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  open() {
    this.details.open = true;

    const height = this.content.scrollHeight;

    this.content.classList.add('is-animating');
    this.content.style.height = '0px';

    requestAnimationFrame(() => {
      this.content.style.height = height + 'px';
    });

    this.content.addEventListener(
      'transitionend',
      () => {
        this.content.classList.remove('is-animating');
        this.content.classList.add('is-open');
        this.content.style.height = 'auto';
      },
      { once: true }
    );
  }

  close() {
    const height = this.content.scrollHeight;

    this.content.classList.add('is-animating');
    this.content.style.height = height + 'px';

    requestAnimationFrame(() => {
      this.content.classList.remove('is-open');
      this.content.style.height = '0px';
    });

    this.content.addEventListener(
      'transitionend',
      () => {
        this.content.classList.remove('is-animating');
        this.details.open = false;
      },
      { once: true }
    );
  }
}

customElements.define('accordion-element', AccordionElement);
